import { Link } from 'react-router';
import { analytics } from 'libs';
import FreeUserWithProFiltersBanner, { type ProFilters } from './FreeUserWithProFiltersBanner';
import FreeTrialBanner from './FreeTrialBanner';
import AIUpgradeBanner from './AIUpgradeBanner';
import PastDuePaymentsBanner from './PastDuePaymentsBanner';
import PlatinumUpgradeBanner from './PlatinumUpgradeBanner';
import RevokedProAccessBrokerageBanner from './RevokedProAccessBrokerageBanner';

const SearchPageBanners = ({ filters }: { filters: ProFilters }) => (
  <>
    <AIUpgradeBanner>
      <div className="fw-bold text-black">
        Your AI Assistant is live!{' '}
        <Link
          data-testid="ai-upgrade-banner-link"
          onClick={analytics.upgrade.bannerLinkClick('AI Assistant', 'AI')}
          to="/ai"
        >
          Try it right now
        </Link>
        .
      </div>
    </AIUpgradeBanner>
    <FreeTrialBanner />
    <FreeUserWithProFiltersBanner filters={filters} />
    <PastDuePaymentsBanner />
    <PlatinumUpgradeBanner />
    <RevokedProAccessBrokerageBanner />
  </>
);

export default SearchPageBanners;
